import { Controller } from "@hotwired/stimulus"

// This controller is used to add the selected or currently filtered leads lists to the user's favorites.
export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      selectedLeadsListIds: { type: Array, default: [] },
    }
  }

  // This function is triggered using stimulus actions to submit a temporary form to verify the selected or filtered
  // leads.
  submit() {
    fetch("/leads-lists/favorite", {
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({ leads_list_ids: this.selectedLeadsListIdsValue, filters: this.filtersValue })
    }).then(response => {
      if (response.status === 201) {
        App.displayFlash("success", i18n.t("js.back.leads_list.favorites.added"))
        return
      }

      App.displayFlash("danger", i18n.t("js.back.leads_list.favorite.error"))
    })
  }

  // This function is triggered using stimulus actions to update the selected leads value.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadsListIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadsListIdsValue = event.detail.dataSets.map(dataSet => dataSet.recordId).filter(Boolean)
    } else {
      this.selectedLeadsListIdsValue = []
    }
  }
}
